import { useState } from "react"
import PropTypes from "prop-types"
import useIsMounted from "react-is-mounted-hook"
import { map, forEach, chain, capitalize } from "lodash"
import pluralize from "pluralize"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material"
import { ANALYTICS_TRACKING } from "helpers/shapes"
import { useTrack } from "helpers/analytics"

export default function DeleteDialog({ items, onClose, onSubmit, type, warningText, renderItem, afterDelete, track }) {
  const isMounted = useIsMounted()
  const [submitError, setSubmitError] = useState(null)
  const [isSubmitting, setSubmitting] = useState(false)

  const trackDelete = useTrack(track)

  function submit() {
    setSubmitError(null)
    setSubmitting(true)
    onSubmit(items, (errorMessage) => {
      if (isMounted()) {
        setSubmitting(false)
        setSubmitError(errorMessage)
      }
      if (!errorMessage) {
        afterDelete()
        forEach(items, trackDelete)
      }
    })
  }

  const pluralized = pluralize(type, items.length)
  const capitalized = chain(pluralized)
    .words()
    .map(capitalize)
    .join(" ")
    .value()

  return (
    <>
      <DialogTitle>Confirm {capitalized} Removal</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please confirm you want to remove the following {pluralized}:
        </DialogContentText>
        <ul className="items-list">
          {map(items, renderItem) }
        </ul>
        { warningText && <DialogContentText>
          {warningText}
        </DialogContentText>}
        {submitError && <DialogContentText className="error-message error" color="error">
          {submitError}
        </DialogContentText> }
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={submit} color="primary" disabled={isSubmitting}>
          {isSubmitting ? "Please Wait" : "Confirm"}
        </Button>
      </DialogActions>
    </>
  )
}

DeleteDialog.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  warningText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  afterDelete: PropTypes.func.isRequired,
  track: ANALYTICS_TRACKING,
}
